<template>
  <section class="filter">
    <h2 class="visually-hidden">Фильтрация данных</h2>
    <CustomSelect
      v-if="filterData.territories"
      :options="filterData.territories"
      :defaultValue="
        filterData.territories.length === 1
          ? null
          : { name: 'Все территории', alias: null }
      "
      :idFn="(option) => option.alias"
      :nameFn="(option) => option.name"
      :modelValue="filter.territory.value"
      @selected="territorySelected"
    ></CustomSelect>
    <IntervalDatePicker
      :from="filter.from"
      :to="filter.to"
      :mode="filter.mode"
      :min-date="stringToDate(filterData.minDateAvailable)"
      @datesChanged="datesChanged"
    ></IntervalDatePicker>
  </section>
</template>

<script>
import { toRefs } from "vue";
import { stringToDate } from "@/modules/date";

import IntervalDatePicker from "./IntervalDatePicker";
import CustomSelect from "./CustomSelect";

export default {
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    filterData: { type: Object, required: true },
  },
  emits: ["update:modelValue"],
  components: { IntervalDatePicker, CustomSelect },
  setup(props, { emit }) {
    const filter = toRefs(props.modelValue);

    function territorySelected(value) {
      filter.territory.value = value;

      emit("update:modelValue", filter);
    }

    function datesChanged(value) {
      filter.from.value = value.range.start;
      filter.to.value = value.range.end;
      filter.mode.value = value.mode;

      emit("update:modelValue", filter);
    }

    return {
      filter,
      territorySelected,
      datesChanged,
      stringToDate,
    };
  },
};
</script>

<style scoped>
.filter {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}
</style>
